// import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, Navigate } from 'react-router-dom';
// import { MainUrl, signInImage } from '../../../Constant/api';
// import { slugs } from '../../../Constant/slugs';
// import ContactUS from '../../ContactUS';
// // import ForgetPasswordComponent from './ForgetPassword';

// export default function Dashboard() {
// 	const [userName, setUserName] = React.useState("")
// 	const [password, setPassword] = React.useState("")
// 	const [confirmPassword, setConfirmPassword] = React.useState("")
// 	const [email, setEmail] = React.useState("")
// 	const [PhoneNumber, setPhoneNumer] = React.useState("")

// 	const [reload, setReload] = React.useState(false)
// 	const [passwordShow, setPasswordShow] = React.useState(false)
// 	const [AlertShow, setAlertShow] = React.useState(false)
// 	const [Alertcomp, setAlertcomp] = React.useState("")
// 	const [Register, setRegister] = React.useState(false)
// 	const [loginSuccess, setLoginSuccess] = React.useState(false)
// 	const [forgetPasswordPressed, setForgetPasswordPressed] = React.useState(false)


// 	return (
// 		<div style={{ backgroundColor: "#f2f3f2", minHeight: "100vh", padding: "10px", overflow: 'hidden' }}>
// 			<div className='row'>
// 				<div className="row">
// 					<div style={{ backgroundColor: "#fff", marginTop: "3vh" }}>
// 						<div>
// 							<div style={{ display: 'flex', justifyContent: 'center', padding: "0 0 50px" }}>
// 								<img
// 									src={signInImage}
// 									height={"80px"}
// 								/>
// 							</div>
// 							<div className='row'>
// 								<div className="col-6">
// 									<Link className="Link" to={slugs.demo_exam}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/5231719.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Demo Exam</div>
// 											<div style={{ fontSize: "10px", margin: "10px" }}>भैसेपाटीमा जस्तै UBT परिक्षा freeमा अभ्यास गर्न </div>
// 										</div>
// 									</Link>
// 								</div>
// 								<div className="col-6">
// 									<Link className="Link" to={slugs.classroom}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/3475156.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Class Room</div>
// 											<div style={{ fontSize: "10px", margin: "10px" }}>Institute को विद्यार्थीका लागि  भैंसेपाटीमा जस्तै UBT परिक्षा दिन </div>
// 										</div>
// 									</Link>
// 								</div>
// 							</div>
// 							<div className='row mt-5'>
// 								<div className="col-6">
// 									<a className="Link" href={MainUrl}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/home.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Home</div>
// 											<div style={{ fontSize: "10px", margin: "10px" }}>गृह पृष्टमा हाम्रो institute को बारेमा जानकारी लिन</div>

// 										</div>
// 									</a>
// 								</div>
// 								<div className="col-6">
// 									<Link className="Link" to={slugs.daily_exam}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/login.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Exam</div>
// 											<div style={{ fontSize: "10px", margin: "10px" }}>घरमै बसेर UBT परिक्षा दिन भैसीपाटीमा जस्तै UBT परिक्षा Format मा</div>
// 										</div>
// 									</Link>
// 								</div>
// 							</div>
// 							<div className='row mt-5'>
// 								<div className="col-6">
// 									<Link className="Link" to={slugs.books}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											{/* <img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/home.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/> */}
// 											<i className='fa fa-book' style={{fontSize:"50px"}} />
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Book</div>
// 											{/* <div style={{ fontSize: "10px", margin: "10px" }}>PDF of all the </div> */}

// 										</div>
// 									</Link>
// 								</div>
// 								<div className="col-6">
// 									<Link className="Link" to={"/profile"}>
// 										<div className='shadow center' style={{ cursor: "pointer", padding: "5px" }}>
// 											{/* <img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/login.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/> */}
// 											<i className='fa fa-user' style={{fontSize:"50px"}}/>
// 											<br />
// 											<div style={{ fontSize: "17px", fontWeight: "bold", margin: "10px" }}>Profile</div>
// 											{/* <div style={{ fontSize: "10px", margin: "10px" }}>घरमै बसेर UBT परिक्षा दिन भैसीपाटीमा जस्तै UBT परिक्षा Format मा</div> */}
// 										</div>
// 									</Link>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div >
// 			{/* <ContactUS/> */}
// 			{
// 				reload &&
// 				<div className="modal" style={{ padding: "50vw" }}>
// 					<div className="dot-pulse"></div>
// 				</div>
// 			}

// 		</div >
// 	)
// }


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../../../Constant/slugs';
import { AdsGETApi, AdsGETApiAuth } from '../../../Constant/api';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import axios from 'axios';

export default function Dashboard() {
	const location = useLocation()
	// const searchParams = location.search("a")
	let params = (new URL(document.location)).searchParams;
	let name = params.get('name');
	const LoginState = useSelector((state) => state.LoginState);
	const imagesArray = [
		"https://api.epsexam.com/wp-content/uploads/2024/01/3.UBT-Exams.png",
		"https://api.epsexam.com/wp-content/uploads/2023/02/Institutes.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2023/02/LiveResults.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2023/02/BatchResults.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2023/02/ExamResults.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2023/02/LiveExam.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2024/01/2.Chapter-Exam.png",
		"https://api.epsexam.com/wp-content/uploads/2024/01/1.Free-Exam.png",
		"https://api.epsexam.com/wp-content/uploads/2023/02/batchExam.jpeg",
		"https://api.epsexam.com/wp-content/uploads/2023/02/allexam.jpeg"
	]
	const data2 = [
		{
			slug: slugs.demo_exam,
			image: "https://api.epsexam.com/wp-content/uploads/2024/01/1.Free-Exam.png",
			backgroundColor: "#fcc10055",
		},
		{
			slug: slugs.exam,
			image: "https://api.epsexam.com/wp-content/uploads/2024/01/3.UBT-Exams.png",
		},
		{
			slug: slugs.daily_exam,
			image: imagesArray[8]
		},
		{
			slug: slugs.chapter_wise_exam,
			image: imagesArray[6]
		},
		{
			slug: slugs.real_time_exam,
			image: imagesArray[5]
		},
		{
			slug: slugs.exam_result_list,
			image: imagesArray[4]
		},
		{
			slug: slugs.daily_exam_result,
			image: imagesArray[3]
		},
		{
			slug: slugs.real_time_exam_result,
			image: imagesArray[2]
		},
		{
			slug: slugs.institute_list,
			image: imagesArray[1]
		},
		// {
		//   slug: "profile",
		//   image: imageArray[0]
		// },
	]

	const data = [
		{
			slug: slugs.demo_exam,
			image: "https://api.everestkorean.com/wp-content/uploads/2024/06/free.png",
			text: "Free Exam",
			backgroundColor: "#fcc10055",
			params: {},
			login: false
		},
		{
			slug: slugs.classroom,
			image: "https://api.everestkorean.com/wp-content/uploads/2024/06/classtest.jpeg",
			text: "Class Test",
			backgroundColor: "#2c66c455",
			params: {},
			login: true
		},
		{
			slug: slugs.exam,
			image: "https://api.everestkorean.com/wp-content/uploads/2024/06/ubt1.jpeg",
			text: "UBT Exam",
			backgroundColor: "#2c66c444",
			params: {},
			login: true,
		},
		{
			slug: slugs.daily_exam,
			image: "https://api.lotusitahari.com/wp-content/uploads/2024/07/package.jpeg",
			text: "Exam Packages",
			backgroundColor: "#2c66c466",
			params: {},
			login: true,
		},
		{
			slug: slugs.books,
			image: "https://api.lotusitahari.com/wp-content/uploads/2024/07/lotus-book-copy.jpeg",
			text: "Books",
			backgroundColor: "#b0d75155",
			params: { slug: "hrd-nepali-book-with-listening" },
			login: false,
		},
		{
			slug: slugs.course,
			image: "https://api.gorkheykorean.com/wp-content/uploads/2024/03/live-1.jpeg",
			text: "Live Classes",
			backgroundColor: "#b0d75155",
			params: {},
			login: false,
		},
	]
	const Block1 = ({ item }) => {
		return (
			<div>
				<Link
					to={
						item.slug == slugs.book_details_student ? `${item.slug}/${item.params.slug}` :
							!item.login ?
								`${item.slug}` :
								LoginState.token !== null ?
									`${item.slug}` :
									"/profile"
					}
				>

					<div style={{
						alignContent: 'center', alignItems: 'center',
						margin: "0px 0 10px 0px",
						borderRadius: "5px"
					}}
						className="home-box-1 center col-12"
					>
						<div>
							<div style={{
								backgroundColor: item.backgroundColor,
								border: "1px solid #bbb",
								borderRadius: "5px"
							}}>
								<img className='col-11 image-home-block'
									style={{
										padding: "4px",
										objectFit: "contain"
									}}
									src={item.image}
								/>
							</div>
							<div className='home-block-text' style={{ color: "#000", marginTop: 10 }}>{item.text}</div>
						</div>
					</div>
				</Link>

			</div>
		)
	}

	const Block2 = ({ item }) => {
		return (
			<div>
				<Link
					to={
						item.slug == slugs.book_details_student ? `${item.slug}/${item.params.slug}` :
							!item.login ?
								`${item.slug}` :
								LoginState.token !== null ?
									`${item.slug}` :
									"/profile"
					}
				>

					<div style={{
						// display: 'flex',
						alignContent: 'center', alignItems: 'center',
						// padding: "5px",
						margin: "0px 0 10px 0px",
						// border: "2px solid #bbb",
						// width: "220px", height: "220px",
						borderRadius: "5px"
					}}
						className="home-box-1 center col-12"
					>
						<div>
							<div style={{
								backgroundColor: item.backgroundColor,
								border: "1px solid #bbb",
								borderRadius: "5px"
							}}>
								<img className='col-11 image-home-block-2'
									style={{

										padding: "4px",
										objectFit: "contain"
									}}
									src={item.image}
								/>
							</div>
							<div className='home-block-text' style={{ color: "#000", marginTop: 10 }}>{item.text}</div>
						</div>
					</div>
				</Link>

			</div>
		)
	}
	const [HotNews, setHotNews] = React.useState([])
	const [sliderDesktop, setSliderDesktop] = React.useState([])
	const [sliderMobile, setSliderMobile] = React.useState([])
	const [sliderDesktop1, setSliderDesktop1] = React.useState([])
	const [sliderMobile1, setSliderMobile1] = React.useState([])
	const [ShowHotNews, setShowHotNews] = React.useState(false)
	const [ThisHotNews, setThisHotNews] = React.useState({
		title: { rendered: "" },
		content: { rendered: "" }
	})
	useEffect(() => {
		AdsGETApi({ per_page: 5 }, slugs.db_slug_hot_news)
			.then((res) => {
				setHotNews(res.data)
				console.log("done")
			})
			.catch(err => {
				console.log(err)
			}).finally(() => {
				// setReload(false)
			})
		// AdsGETApiAuth({ per_page: 5 }, slugs.db_slug_hot_news)
		AdsGETApi({ _fields: "meta" }, "images")
			.then((res) => {
				if (res.data.length !== 0) {
					if (res.data[0].meta.picture_url_list.length !== 0) {
						setSliderMobile(JSON.parse(res.data[0].meta.picture_url_list))
						setSliderDesktop(JSON.parse(res.data[0].meta.web_picture_url_list))
						setSliderMobile1(JSON.parse(res.data[0].meta.picture_url_list1))
						setSliderDesktop1(JSON.parse(res.data[0].meta.web_picture_url_list1))
					
					}
				}
				console.log("done")
			})
			.catch(err => {
				console.log(err)
			}).finally(() => {
			})

	}, [])


	return (
		<div>
			<div>
				{/* <div style={{ width: "100%", padding: "7px", marginLeft: "-10px", backgroundColor: "#0025f8" }}>
          <Link className="Link" to={slugs.daily_exam} style={{ color: "#fff", fontWeight: "bold" }}>
            New Offer Available in batch exam
          </Link>
        </div> */}

				{sliderDesktop.length !== 0 &&
					<CaroselView
						HeaderDesktopTabimagesPass={sliderDesktop}
						HeaderMobileimagesPass={sliderMobile}
						transitionTime={500}
						interval={3000}
						centerSlidePercentage={100}
					/>
				}
				{/* <h2 style={{ marginLeft: 10, marginTop: 0, textDecorationLine: "underline" }}>Our Service</h2> */}
				<div className="row" style={{ margin: "10px", marginTop: 0 }}>
					{/* {data.map((item, index) => (
						<div key={index} className="col-lg-2 col-3" style={{ padding: "0 4px" }}>
							{item.slug == "AllVideo" ?
								<div >
									<a target="_blank" href={item.params.link}>
										<div style={{ alignContent: 'center', alignItems: 'center', margin: "10px 0px", borderRadius: "5px" }}
											className="home-box center col-12"
										>
											<div>
												<div style={{
													backgroundColor: item.backgroundColor,
													border: "1px solid #bbb",
													borderRadius: "5px"
												}}>
													<img className='col-11 image-home-block'
														style={{
															// height: "100px",
															padding: "4px",
															objectFit: "contain"
														}}
														src={item.image}
													/>
												</div>
												<div className='home-block-text' style={{ color: "#000", marginTop: 10 }}>{item.text}</div>
											</div>
										</div>
									</a>
								</div>
								:
								<Block item={item} />
							}
						</div>
					))} */}
					<div className="col-lg-4 col-6" style={{ padding: "0 4px" }}>
						<Block1 item={data[0]} />
					</div>
					<div className="col-lg-4 col-6" style={{ padding: "0 4px" }}>
						<Block1 item={data[2]} />
					</div>
					<div className='d-lg-block d-none col-lg-4 col-6'>
						<Block1 item={data[5]} />
					</div>

				</div>
				<div className="row" style={{ margin: "10px", marginTop: 0 }}>
					<div className='d-lg-none d-block'>
						<Block2 item={data[1]} />
					</div>
				</div>
				<div className='d-lg-none d-block'>
					<div className="row" style={{ margin: "10px", marginTop: 0 }}>
						<Block2 item={data[3]} />
					</div>
				</div>
				<div className='d-lg-block d-none'>
					<div className="row" style={{ margin: "10px", marginTop: 0 }}>
						<div className="col-6" style={{ padding: "0 4px" }}>
							<Block2 item={data[1]} />
						</div>
						<div className="col-6" style={{ padding: "0 4px" }}>
							<Block2 item={data[3]} />
						</div>
					</div>
				</div>
				{sliderDesktop1.length !== 0 &&
					<CaroselView
						HeaderDesktopTabimagesPass={sliderDesktop1}
						HeaderMobileimagesPass={sliderMobile1}
						transitionTime={500}
						interval={3000}
						centerSlidePercentage={100}
					/>
				}
				<div className="row" style={{ margin: "10px", marginTop: 0 }}>
					<div className='d-lg-none d-block'>
						<Block2 item={data[4]} />
					</div>
				</div>
				<div className='d-lg-none d-block'>
					<div className="row" style={{ margin: "10px", marginTop: 0 }}>
						<Block2 item={data[5]} />
					</div>
				</div>
				<div className='d-lg-block d-none'>
					<div className="row" style={{ margin: "10px", marginTop: 0 }}>
						<div className="col-6" style={{ padding: "0 4px" }}>
							<Block2 item={data[4]} />
						</div>
						<div className="col-6" style={{ padding: "0 4px" }}>
							<Block2 item={data[5]} />
						</div>
					</div>
				</div>
				{/* <img src="https://api.epsexam.com/wp-content/uploads/2024/09/banner-web.jpeg"
              style={{width: "100%" }}
            /> */}
			</div>
		</div>
	)
}

const CaroselView = ({
	HeaderDesktopTabimagesPass,
	HeaderMobileimagesPass,
	transitionTime,
	interval,
	centerSlidePercentage
}) => {
	return (
		<section id="carosel-1">
			<div className="Home-Carosel-Desktop-Style p-1">
				<Carousel
					autoPlay={true}
					swipeable={true}
					emulateTouch={true}
					infiniteLoop={true}
					dynamicHeight={true}
					showThumbs={false}
					transitionTime={transitionTime}
					interval={interval}
					centerMode={true}
					centerSlidePercentage={centerSlidePercentage}
				>
					{HeaderDesktopTabimagesPass.map((item, index) => (
						<div key={index}
							className="Carosel-Image"
						>
							<img src={item}
								className="homeImage"
							/>
						</div>
					))}
				</Carousel>
			</div>
			<div className="Home-Carosel-Mobile-Style p-1">
				<Carousel
					dynamicHeight={false}
					showThumbs={false}
					infiniteLoop={true}
					autoPlay={true}
					transitionTime={transitionTime}
					interval={interval}
				>
					{HeaderMobileimagesPass.map((item, index) => (
						<div key={index}
							className="Carosel-Image"
						>
							<img src={item}
								className="homeImage"
							/>
						</div>
					))}
				</Carousel>
			</div>
		</section>

	)
}